import * as Yup from 'yup';

const EscalationSchema = Yup.object().shape({
  projectId: Yup.number()
    .integer('Project ID must be an integer')
    .positive('Project ID must be positive')
    .required('Project is required'),
  description: Yup.string()
    .min(1, 'Description is required')
    .required('Description is required'),
  severity: Yup.string()
    .oneOf(['low', 'medium', 'high', 'critical'], 'Invalid severity')
    .default('medium'),
});

export default EscalationSchema;

